export const mutations = {
  setModalViewInvestment(state, payload) {
    state.modalViewInvestment = payload;
  },
  setInvestments(state, payload) {
    state.investments = payload;
  },
  setInvestment(state, payload) {
    state.investment = payload;
  },
  setPayInvestment(state, payload) {
    state.payInvestment = payload
  },
  setListPayInvestments(state, payload) {
    state.listPayInvestments = payload
  },
};

export default {};
